import { DIYVideoProps } from '../types';
import { CatHeading } from '@blocks-react/components/Heading';
import cx from 'classnames';
import { CatTooltip } from '@blocks-react/components/Tooltip';
import styles from '../DIY.module.scss';

export const DIYVideo = ({ item, classname }: DIYVideoProps) => {
  return (
    <>
      <iframe
        title={item.title}
        src={item.video_url}
        frameBorder="0"
        scrolling="no"
        allow="autoplay; encrypted-media"
        loading="lazy"
        className={cx('d-block w-100 mb-3', classname)}
        allowFullScreen
      />
      {item.title && (
        <CatTooltip position="top">
          <CatHeading slot="trigger" variant="label-lg" level="h4">
            <div className={'text-truncate'}>{item.title}</div>
          </CatHeading>
          <p className={`${styles['c-video-section__title-tooltip']} m-0`}>{item.title}</p>
        </CatTooltip>
      )}
    </>
  );
};
